var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "10px",
    height: "20px",
    viewBox: "0 0 10 20",
    enableBackground: "new 0 0 10 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 10,
    height: 20,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUBAMAAABGwLFlAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEXUUKXUUKXUUKXUUKXU UKXUUKXUUKXUUKXUUKXUUKXUUKXUUKXUUKXUUKX///+JpOzQAAAADnRSTlMAEwPryQ8tzBXT5yTk 0lkfvp4AAAABYktHRA5vvTBPAAAAB3RJTUUH5wMKAy0vZjXCwQAAADRJREFUCNdjEGIAAZMAEJns CiLZsHEqwBzLBhCVNQNEcp9FkGARiCxYJUQX2AQkJtQWsI0A/sYM3fv1DVoAAAAldEVYdGRhdGU6 Y3JlYXRlADIwMjMtMDMtMTBUMDI6NDU6NDcrMDE6MDDe6dzEAAAAJXRFWHRkYXRlOm1vZGlmeQAy MDIzLTAzLTEwVDAyOjQ1OjQ3KzAxOjAwr7RkeAAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.d990ce4aeff10d7e01d7800960813372.svg";
export { ForwardRef as ReactComponent };